import { AdminService, SystemSettingKey } from './admin.service';

export type SystemFlagKey = SystemSettingKey;

type CacheEntry = { value: boolean; expiresAt: number };

const TTL_MS = 30_000;

const cache = new Map<SystemFlagKey, CacheEntry>();

const getStoredRole = (): string | null => {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem('auth_user');
  if (!raw) return null;
  try {
    const user = JSON.parse(raw) as { role?: unknown };
    return typeof user.role === 'string' ? user.role : null;
  } catch {
    return null;
  }
};

export const SystemService = {
  async getFlag(key: SystemFlagKey): Promise<boolean> {
    const now = Date.now();
    const cached = cache.get(key);
    if (cached && cached.expiresAt > now) return cached.value;

    const role = getStoredRole();
    const settings = role === 'admin'
      ? await AdminService.getSystemSettings().catch(() => AdminService.getPublicSystemSettings())
      : await AdminService.getPublicSystemSettings();
    const map = new Map<SystemSettingKey, boolean>();
    for (const s of settings || []) map.set(s.key, !!s.value);

    const value = !!map.get(key);
    cache.set(key, { value, expiresAt: now + TTL_MS });
    return value;
  },

  invalidate(key?: SystemFlagKey) {
    if (key) cache.delete(key);
    else cache.clear();
  }
};
